import { Component, inject } from '@angular/core';

import { combineLatest, EMPTY, first, map, switchMap } from 'rxjs';

import { AuthService, IdToken } from '@auth0/auth0-angular';
import { Store } from '@ngxs/store';

import { UserLogIn } from './shared/state/app.actions';

@Component({
  selector: 'sh-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  readonly #authService = inject(AuthService);
  readonly #store = inject(Store);

  constructor() {
    this.#authService.isAuthenticated$
      .pipe(
        switchMap((isAuthenticated: boolean) =>
          isAuthenticated
            ? combineLatest([
                this.#authService.idTokenClaims$.pipe(first(Boolean)),
                this.#authService.getAccessTokenSilently().pipe(first(Boolean))
              ]).pipe(
                map(
                  ([
                    idToken,
                    accessToken
                  ]: readonly [
                    IdToken,
                    string
                  ]) => ({ idToken, accessToken })
                ),
                switchMap(({ idToken, accessToken }) => this.#store.dispatch(new UserLogIn(accessToken, idToken.exp!, idToken.__raw, null)))
              )
            : EMPTY
        )
      )
      .subscribe();
  }
}
